import { render, staticRenderFns } from "./OrderTypeChangeSuccess.vue?vue&type=template&id=3e6d77e7&scoped=true&"
import script from "./OrderTypeChangeSuccess.vue?vue&type=script&lang=js&"
export * from "./OrderTypeChangeSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e6d77e7",
  null
  
)

export default component.exports